import TableOperationUtils from './table-operation-utils';
var Model = /** @class */ (function () {
    function Model() {
    }
    Model.revealSchema = function (modelClass) {
        var tableInfo = TableOperationUtils.getTableInfo(modelClass.prototype);
        if (!tableInfo)
            return null;
        return TableOperationUtils.convertTableInfoToSchema(tableInfo);
    };
    return Model;
}());
export default Model;
//# sourceMappingURL=model.js.map